import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { TranslateService } from '../../../api/translate.service';
import { 
  fieldAddressLine1Col,
  fieldAddressLine2Col, 
  fieldApprovedByCol,
  fieldBillingOfficeCol,
  fieldBuildingNameCol,
  fieldCarParkSpacesCol,
  fieldCompanyTypeCol,
  fieldConfidentialityStatusCol,
  fieldContractTypeCol,
  fieldCountryCol,
  fieldCreatedByCol,
  fieldCurrencyCol,
  fieldCustomerNameCol,
  fieldDateCol,
  fieldDedicatedClientNameCol,
  fieldDistrictCol,
  fieldExecutionDateCol,
  fieldGridIdCol,
  fieldGstRateCol, 
  fieldIdCol,
  fieldInvoiceFeeBasisCol,
  fieldInvoiceHeaderCol,
  fieldInvoiceIdCol,
  fieldInvoiceTypeCol,
  fieldLocalityCol,
  fieldMiqIdCol,
  fieldMoneyInTrustCol,
  fieldOppNumberCol,
  fieldOpportunityCol,
  fieldOpportunityInstallmentCol,
  fieldOpportunitySourceCol,
  fieldPostcodeCol,
  fieldPrimaryEmployeeFunctionalUnitCol,
  fieldPrimaryEmployeeFunctionalUnitIdCol,
  fieldPrimaryEmployeeIdCol,
  fieldPrimaryEmployeeManagingOfficeCol,
  fieldPrimaryEmployeeManagingOfficeIdCol,
  fieldPrimaryEmployeeNameCol,
  fieldPropertyAreaCol,
  fieldPropertyManagedCol,
  fieldPropertySubtypeCol, 
  fieldPropertyTypeCol,
  fieldPurchaseOrderCol,
  fieldRegionCol,
  fieldRepresentedPartyCol,
  fieldRepRolCol,
  fieldSizeAreaMeasureCol,
  fieldSubmittedByCol,
  fieldSuburbCol,
  fieldTeamCol,
  fieldTransactionTypeCol,
  fieldMiqAvailabilityIdCol,
  fieldValuationFeeCol,
  fieldWeightingPercentageCol,
  fieldBuildingNlaCol,
  fieldMarketValueCol, 
  fieldLandCol,
  fieldLandAreaMeasureCol,
  fieldReppedCustomer,
  fieldCbreFeeCol,
  fieldCbreFeeFumoBalCol,
  fieldNotesCol,
  fieldMasterBillingInvoiceCol,
  fieldRoomsCol
} from '../../../utils/ag-grid/column-defs';

@Injectable({
  providedIn: 'root'
})
export class ValuationPropertyCustomerReportService {

  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_no',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LEASE_EXECUTED_DATE'),
        key: 'execution_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CONTRACT_TYPE'),
        key: 'contract_type',
        width: 30,
        style: { ...settings.middle }
      },
       {
        header: this.translateService.getTranslation('MIQ_AVAILABILITY_ID'),
        key: 'availability_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_GRID_ID'),
        key: 'grid_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE'),
        key: 'property_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
        key: 'property_subtype',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_AREA'),
        key: 'size',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
        key: 'size_measurement',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LAND'),
        key: 'land',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LAND_AREA_MEASURE'),
        key: 'land_area_measure',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ROOMS'),
        key: 'rooms',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CAR_PARK_SPACES'),
        key: 'car_spaces',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_VALUE'),
        key: 'valuation_fee',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PORTFOLIO_NAME'),
        key: 'portfolio_name',
        width: 30,  
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('WEIGHTING_PROPERTY_TYPE'),
        key: 'weighting_property_type',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('WEIGHTING_PERCENTAGE'),
        key: 'weighting_percentage',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BUILDING_NLA'),
        key: 'building_nla',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BUILDING_NLA_UOM'),
        key: 'building_nla_uom',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MARKET_VALUE'),
        key: 'market_value',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MANAGED_BY_CBRE'),
        key: 'managed_by_cbre',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
        key: 'primary_employee_functional_unit',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
        key: 'primary_employee_managing_office',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REPRESENTATION_ROLE'),
        key: 'rep_role',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_NAME'),
        key: 'represented_party',
        width: 30,
        style: { ...settings.middle }
      },
        {
        header: this.translateService.getTranslation('REPRESENTED_CONTACT_NAME'),
        key: 'represented_contact_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COMPANY_TYPE'),
        key: 'company_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
        key: 'dedicated_client_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUSTOMER_NAME'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COMPANY_TYPE'),
        key: 'bill_to_company_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
        key: 'bill_to_dedicated_client_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REPPED_CUSTOMER_ID'),
        key: 'repped_customer_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PURCHASE_ORDER'),
        key: 'purchase_order_number',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MONEY_IN_TRUST'),
        key: 'money_in_trust',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILLING_OFFICE'),
        key: 'billing_office',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('GST_RATE'),
        key: 'gst_rate',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_FEE_BASIS'),
        key: 'invoice_fee_basis',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INVOICE_HEADER'),
        key: 'invoice_header',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_FEE_$'),
        key: 'cbre_fee_total',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CBRE_REVENUE_$'),
        key: 'cbre_revenue_total',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BALANCE'),
        key: 'balance',
        width: 30,
        style: { ...settings.middle },  
      },
      {
        header: this.translateService.getTranslation('NOTES'),
        key: 'notes',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INTERNAL_NOTES'),
        key: 'internal_notes',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MASTER_BILLING_INVOICE'),
        key: 'master_billing_invoice',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
        key: 'confidentiality_status',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle },
      },
      
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      },
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_no',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
        minWidth: 160,
      },
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },    
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },     
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },   
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      },
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      },
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },
      {
        ...fieldExecutionDateCol,
        width: 200,
        headerName: this.translateService.getTranslation('EXECUTION_DATE'),
      },            
      {
        ...fieldContractTypeCol,
        headerName: this.translateService.getTranslation('CONTRACT_TYPE'),
      },
      {
        ...fieldMiqAvailabilityIdCol,
        headerName: this.translateService.getTranslation('MIQ_AVAILABILITY_ID'),
      },
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },
      {
        ...fieldGridIdCol,
        field: 'grid_id',
        headerName: this.translateService.getTranslation('PROPERTY_GRID_ID'),
      },
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },      
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },      
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },      
      {
        ...fieldPropertyTypeCol,
        minWidth: 150,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE'),
      },      
      {
        ...fieldPropertySubtypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'size',
        headerName: this.translateService.getTranslation('PROPERTY_AREA'),
      },
      {
        ...fieldSizeAreaMeasureCol,
        field: 'size_measurement',
        headerName: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
      },
      {
        ...fieldLandCol,
        headerName: this.translateService.getTranslation('LAND'),
      },
      {
        ...fieldLandAreaMeasureCol,
        headerName: this.translateService.getTranslation('LAND_AREA_MEASURE'),
      },
      {
        ...fieldRoomsCol,
        headerName: this.translateService.getTranslation('ROOMS'),
      },
      {
        ...fieldCarParkSpacesCol,
        field: 'car_spaces',
        headerName: this.translateService.getTranslation('CAR_PARK_SPACES'),
      },
      {
        ...fieldValuationFeeCol,
        headerName: this.translateService.getTranslation('PROPERTY_VALUE'),
        minWidth: 180
      },
      {
        field: 'portfolio_name',
        headerName: this.translateService.getTranslation('PORTFOLIO_NAME'),
        minWidth: 200,
        sortable: true,
        filter: true,
        resizable: true
      },
      {
        ...fieldPropertyTypeCol,
        field: 'weighting_property_type',
        headerName: this.translateService.getTranslation('WEIGHTING_PROPERTY_TYPE'),
        minWidth: 190
      },
      {
        ...fieldWeightingPercentageCol,
        headerName: this.translateService.getTranslation('WEIGHTING_PERCENTAGE'),
        minWidth: 190
      },
      {
        ...fieldBuildingNlaCol,
        headerName: this.translateService.getTranslation('BUILDING_NLA'),
        minWidth: 180
      },
      {
        ...fieldBuildingNlaCol,
        field: 'building_nla_uom',
        headerName: this.translateService.getTranslation('BUILDING_NLA_UOM'),
        minWidth: 180
      },
      {
        ...fieldMarketValueCol,
        headerName: this.translateService.getTranslation('MARKET_VALUE'),
        minWidth: 180
      },
      {
        ...fieldPropertyManagedCol,
        headerName: this.translateService.getTranslation('MANAGED_BY_CBRE'),
      },
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      },      
      {
        ...fieldRepRolCol,
        field: 'rep_role',
        headerName: this.translateService.getTranslation('REP_ROLE'),
      },           
      {
        ...fieldRepresentedPartyCol,
        headerName: this.translateService.getTranslation('CUSTOMER_NAME'),
      },
      {
        ...fieldCompanyTypeCol,
        headerName: this.translateService.getTranslation('COMPANY_TYPE'),
      },     
      {
        ...fieldDedicatedClientNameCol,
        field: 'dedicated_client_name',
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
      },            
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        headerName: this.translateService.getTranslation('BILL_TO_CUSTOMER_NAME'),
      },     
      {
        ...fieldCompanyTypeCol,
        field: 'bill_to_company_type',
        headerName: this.translateService.getTranslation('COMPANY_TYPE'),
      },      
      {
        ...fieldDedicatedClientNameCol,
        field: 'bill_to_dedicated_client_name',
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
      },      
      {
        ...fieldReppedCustomer,
        field: 'repped_customer_id',
        headerName: this.translateService.getTranslation('REPPED_CUSTOMER_ID'),
      },
      {
        ...fieldPurchaseOrderCol,
        field: 'purchase_order_number',
        headerName: this.translateService.getTranslation('PURCHASE_ORDER'),
      },      
      {
        ...fieldMoneyInTrustCol,
        headerName: this.translateService.getTranslation('MONEY_IN_TRUST'),
      },
      {
        ...fieldBillingOfficeCol,
        headerName: this.translateService.getTranslation('BILLING_OFFICE'),
      },                  
      {
        ...fieldGstRateCol,
        headerName: this.translateService.getTranslation('GST_RATE'),
      },    
      {
        ...fieldInvoiceFeeBasisCol,
        headerName: this.translateService.getTranslation('INVOICE_FEE_BASIS'),
      },         
      {
        ...fieldInvoiceHeaderCol,
        minWidth: 200,
        headerName: this.translateService.getTranslation('INVOICE_HEADER'),
      },
      {
        ...fieldConfidentialityStatusCol,
        headerName: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
      },
      {
        ...fieldCbreFeeCol,
        field: 'cbre_fee_total',
        headerName: this.translateService.getTranslation('CBRE_FEE_$'),
      },
      {
        ...fieldCbreFeeCol,
        field: 'cbre_revenue_total',
        headerName: this.translateService.getTranslation('CBRE_REVENUE_$'),
      },
      {
        ...fieldCbreFeeFumoBalCol,
        field: 'balance',
        headerName: this.translateService.getTranslation('BALANCE'),
      },
      {
        ...fieldNotesCol,
        field: 'notes',
        headerName: this.translateService.getTranslation('NOTES'),
      },
      {
        ...fieldNotesCol,
        field: 'internal_notes',
        headerName: this.translateService.getTranslation('INTERNAL_NOTES'),
      },
      {
        ...fieldMasterBillingInvoiceCol,
        minWidth: 180,
        headerName: this.translateService.getTranslation('MASTER_BILLING_INVOICE'),
      },
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },            
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      },               
    ];
  }
}
